import React, { useEffect, useState } from 'react'
import FooterEN from './FooterEN'
import FooterJP from './FooterJP'

const Footer = () => {
    const [lang, setlang] = useState(<FooterEN />)
	useEffect(() => {
		const currentPath = window.location.pathname.split('/')[1]

		if(currentPath && currentPath === 'jp') {
			setlang(<FooterJP /> )
		}
	}, [])
  return (
    <> {lang} </>
  )
}

export default Footer
